import React, {PureComponent} from 'react';
import './ChoosePhoneComponent.less';
import {RadioButton, RadioGroup} from '@homeaway/react-form-components';
import {ButtonLink, ButtonPrimary} from '@homeaway/react-buttons';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {FormInput} from '@homeaway/react-form-components';
import {maskPhone} from '../../util/phoneUtils';
import mfaClient from '../../util/mfaClient';
import {AsYouType, parsePhoneNumberFromString} from 'libphonenumber-js';

class ChoosePhoneComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            phoneNumber: null,
            inputPhone: '',
            nonExistingPhoneError: '',
            inputPhoneHelpLabel: 'Enter Phone Number',
            choosenPhone: null,
            countryCodePhone: ''
        };
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value, inputPhone: '', 'choosenPhone': this.props.phoneList[event.target.value]});
    };

    handleBackClick = () => {
        const {updatePage} = this.props;
        updatePage('chooseContactType');
    };

    changeSuccess = () => {
        const {updatePage, setPhoneNumber, publicUuid} = this.props;
        const contactType = this.props.contactType;
        setPhoneNumber(this.state.choosenPhone);
        this.sendChallenge(this.props.challengeTicket, this.props.contactType, this.state.choosenPhone)
            .then(() => {
                this.context.trigger('mfa.challenge.attempt', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase()});
                updatePage('verifyCode');
            }).catch((error) => {
                if (this.userHasOverLimitPhones() && error && error.status === 403) {
                    this.setState({nonExistingPhoneError: this.props.lingua.read('lex.mfa.contact.input.error')});
                } else {
                    this.context.trigger('mfa.challenge.failure', {publicuuid: publicUuid, mfatype: 'challenge_2fa', mfamethod: contactType.toLowerCase(), failurereason: 'service-failure'});
                    this.props.handleError(this.props.lingua.read('error.generic'), '');
                }
            });
    };

    sendChallenge = (challengeTicket, contactType, phoneNumber) => {
        return mfaClient.challenge(challengeTicket, contactType, phoneNumber);
    };

    formatPhone = (event) => {
        let formatter = new AsYouType();
        let rawInput = event.target.value[0] === '+' ? event.target.value : `+${event.target.value}`;
        formatter.input(rawInput);
        this.setState({'inputPhone': (event.target.value), 'inputPhoneHelpLabel': this.getLabelText(event.target.value), 'phoneNumber': null, choosenPhone: null, nonExistingPhoneError: ''});
        if (formatter.extractCountryCallingCode()) {
            const phonepayload = parsePhoneNumberFromString(`+${formatter.countryCallingCode}${formatter.nationalNumber}`);
            if (phonepayload && phonepayload.isValid()) {
                this.setState({'inputPhone': (`${formatter.countryCallingCode} ${phonepayload.formatNational()}`),
                    choosenPhone: {'countryCode': formatter.countryCallingCode, 'phone': formatter.nationalNumber}});
            }
        }
    };

    getLabelText = (input) => {
        return input === 0 ? this.props.lingua.read('lex.mfa.contact.input.label.enter.phone') : this.props.lingua.read('lex.mfa.contact.input.label.secure.number');
    }

    inputPhoneUI = () => {
        return (
            <div id="freeFormPhoneInput" className="ChoosePhoneFreeForm">
                <div className="message">
                    <p>{this.props.lingua.read('lex.mfa.contact.input.label.not.found')}</p>
                </div>
                <FormInput id={'choosePhoneFreeFormPhoneInput'} label={this.state.inputPhoneHelpLabel}
                    type={'tel'} onChange={this.formatPhone} errorMsg={this.state.nonExistingPhoneError}
                    value={this.state.inputPhone}
                />
            </div>
        );
    };

    userHasOverLimitPhones = () => {
        return this.props.numberOfSecurityPhones !== this.props.phoneList.length;
    };

    render() {
        return (
            <>
                <div className="PhoneChooser">
                    <div className="title">
                        <p>{this.props.lingua.read('lex.owner.phone.subtitle')}</p>
                    </div>
                    <div className="radios">
                        { (!this.props.phoneList || this.props.phoneList.length > 1) && (
                            <RadioGroup id="phoneNumberList" name="phoneNumber" ariaLabel="">
                                {
                                    this.props.phoneList.map((option, index) => {
                                        return (
                                            <RadioButton
                                                id={index}
                                                key={index}
                                                label={maskPhone(option.phone)}
                                                value={index}
                                                checked={this.state.phoneNumber === (index).toString()}
                                                onChange={this.handleChange}
                                            />
                                        );
                                    })
                                }
                            </RadioGroup>
                        )}
                    </div>
                    {(this.userHasOverLimitPhones() && this.inputPhoneUI())}
                    <div className="radiosnext">
                        <ButtonLink id="back" name="back" className="Link" label={this.props.lingua.read('lex.owner.button.back')} onClick={this.handleBackClick} />
                        <ButtonPrimary id="next" name="next" type="button" label={this.props.lingua.read('lex.owner.button.next')} disabled={!this.state.choosenPhone} onClick={this.changeSuccess} />
                    </div>
                </div>
            </>
        );
    }
}

ChoosePhoneComponent.contextType = TrackingContext;
export default ChoosePhoneComponent;
